import React from "react";
import {Card, CardBody} from "reactstrap";

const KOREM_USA_REPORT = "https://www.korem.com/reports/iamdatable2/?id=koremUSA";
const KOREM_CANADA_Report = "https://www.korem.com/reports/iamdatable2/?id=koremCanada";
const GEO_MTL_END_DATE_PLUS_A_DAY = new Date(2019, 11, 15, 23, 59, 59, 0);

const EmptyDataViz = () => {
    const exampleReport = new Date() > GEO_MTL_END_DATE_PLUS_A_DAY ? KOREM_USA_REPORT : KOREM_CANADA_Report;

    return (
        <Card>
            <CardBody>
                <div align="center">
                    <h3>There's no data for your chosen address. <br/>
                        If you would like to see this data from an address in a busy city, please follow the
                        link. <br/>
                    </h3>
                    <button className="rectangular-button">
                        <a rel="noopener noreferrer" target="_blank"
                           href={exampleReport}>See data >></a>
                    </button>
                </div>
            </CardBody>
        </Card>)
};

export default EmptyDataViz;